import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=3c224eaa&scoped=true&"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts&"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts&"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=3c224eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c224eaa",
  null
  
)

export default component.exports